export function getCookies(): { name: string; value: string }[] {
  return document.cookie.split(';').map(cookie => {
    const [name, value] = cookie.split('=').map(c => c.trim());
    return { name, value: decodeURIComponent(value) };
  });
}

export const setCookie = (name: string, value: string, seconds = 600) => {
  const expires = new Date(Date.now() + seconds * 1000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value,
  )}; expires=${expires}; path=/; SameSite=Lax`;
};

export const getCookie = (name: string) => {
  const match = document.cookie
    .split(';')
    .find(cookie => cookie.split('=').map(c => c?.trim())?.[0] === name);

  return match ? match.split('=')[1] : undefined;
};

export const deleteCookie = (name: string) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export const setCookieWithExpUnix = (
  name: string,
  value: string,
  expirationUnix?: number,
) => {
  if (!expirationUnix) {
    return;
  }
  const expirationMilliseconds = expirationUnix * 1000;
  const expirationDate = new Date(expirationMilliseconds);
  const expires = 'expires=' + expirationDate.toUTCString();
  document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Lax`;
};
